import { VideoContentData } from '../../../types/contentTypes';
import { textToParagraphs } from '../../../utils/functions';
import { useStorageFileUrl } from '../../../utils/hooks';
import VideoPlayer from '../../molecules/video-player/VideoPlayer';

interface VideoContentProps {
  content: VideoContentData;
  onComplete: (() => void) | undefined;
  // isPreview?: boolean;
}

function VideoContent({ content, onComplete }: VideoContentProps) {
  const storagePathUrl = useStorageFileUrl(content.storagePath);
  const videoSourceUrl = storagePathUrl || content.url;

  // const videoIdRef = useRef<string>('');
  // const isYoutubeRef = useRef<boolean>(false);

  /*  const regExp =
    /(?:youtu\.be\/|youtube(?:-nocookie)?\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^/&]{10,12})/;*/
  /*  const videoId = content.storagePath.match(regExp);
  if (videoId != null) {
    videoIdRef.current = videoId[1];
    isYoutubeRef.current = true;
  } else {
    videoIdRef.current = content.storagePath;
  }*/

  return (
    <section className="video-content">
      <h2 className="strong-heading mb-8">{content.headline}</h2>
      <div className="mb-12">{textToParagraphs(content.description)}</div>
      {videoSourceUrl && <VideoPlayer onPlay={onComplete} className="mx-auto" url={videoSourceUrl} />}
    </section>
  );
}

export default VideoContent;
